import * as culture from "client_legacy/ndaw/culture";
import { DocumentKind } from "client/Api/Documents/SharePoint/common";
import { NewDocumentType } from "client/Api/Documents/common";
import { UnreachableCaseError } from "client_legacy/ndaw/errors";

interface OpenLocalizations {
	online: {
		action: string;
		app: string;
	};
	local: {
		action: string;
		app: string;
	};
}

function getOpenLocalizationsForExtension(extension: string): OpenLocalizations {
	switch (extension.toLowerCase()) {
		case ".doc":
		case ".docx":
		case ".dotx":
		case ".docm":
		case ".dotm":
			return getOpenLocalizationsForDocumentKind(DocumentKind.Word);
		case ".xlsm":
		case ".xls":
		case ".xlsx":
			return getOpenLocalizationsForDocumentKind(DocumentKind.Excel);
		case ".potx":
		case ".ppt":
		case ".pptx":
		case ".pptm":
			return getOpenLocalizationsForDocumentKind(DocumentKind.PowerPoint);
		case ".one":
			return getOpenLocalizationsForDocumentKind(DocumentKind.OneNote);
		case ".vsd":
		case ".vsdx":
			return getOpenLocalizationsForDocumentKind(DocumentKind.Visio);
		default:
			return {
				online: {
					action: culture.localize("_Open"),
					app: ""
				},
				local: {
					action: culture.localize("_OpenInLocalApp"),
					app: ""
				}
			};
	}
}

function getOpenLocalizationsForDocumentKind(kind: DocumentKind): OpenLocalizations {
	switch (kind) {
		case DocumentKind.Word:
			return getOpenLocalizationsWithAppNames(culture.localize("_WordOnline"), culture.localize("_Word"));
		case DocumentKind.Excel:
			return getOpenLocalizationsWithAppNames(culture.localize("_ExcelOnline"), culture.localize("_Excel"));
		case DocumentKind.PowerPoint:
			return getOpenLocalizationsWithAppNames(culture.localize("_PowerPointOnline"), culture.localize("_PowerPoint"));
		case DocumentKind.OneNote:
			return getOpenLocalizationsWithAppNames(culture.localize("_OneNoteOnline"), culture.localize("_OneNote"));
		case DocumentKind.Visio:
			return getOpenLocalizationsWithAppNames(culture.localize("_VisioOnline"), culture.localize("_Visio"));
		default:
			throw new UnreachableCaseError(kind);
	}
}

function getOpenLocalizationsForNewDocumentType(newDocumentType: NewDocumentType): OpenLocalizations {
	switch (newDocumentType) {
		case NewDocumentType.Word:
			return getOpenLocalizationsForDocumentKind(DocumentKind.Word);
		case NewDocumentType.Excel:
			return getOpenLocalizationsForDocumentKind(DocumentKind.Excel);
		case NewDocumentType.PowerPoint:
			return getOpenLocalizationsForDocumentKind(DocumentKind.PowerPoint);
		case NewDocumentType.OneNote:
			return getOpenLocalizationsForDocumentKind(DocumentKind.OneNote);
		default:
			throw new UnreachableCaseError(newDocumentType);
	}
}

function getOpenLocalizationsWithAppNames(onlineAppName: string, localAppName: string): OpenLocalizations {
	const template = culture.localize("_OpenInAppName");
	return {
		online: {
			action: template.replace("{0}", onlineAppName),
			app: onlineAppName
		},
		local: {
			action: template.replace("{0}", localAppName),
			app: localAppName
		}
	};
}

export {
	getOpenLocalizationsForExtension,
	getOpenLocalizationsForDocumentKind,
	getOpenLocalizationsForNewDocumentType,
	type OpenLocalizations
};
